<h2 mat-dialog-title class="title">Replace Existing Document <span class="material-icons-outlined fixed-pos" (click)="cancelHandler()" >
    close
    </span></h2>
<mat-dialog-content class="mat-typography">
    <p class="with-newlines">A document with the name {{data.name}} already exists. Do you wish to replace it?</p>
    <p class="with-newlines">Note: modify Document Suffix if you wish to save this as a separate document</p>
</mat-dialog-content>
<mat-dialog-actions align="end" class="top-border">
    <button mat-raised-button class="mat-raised-button mat-primary sg-primary-button ml-2 sg-upload-button" cdkFocusInitial   (click)="replaceHandler()">Replace</button>
    <button mat-raised-button class="sg-primary-stroked mat-stroked-button ml-4" (click)="cancelHandler()">Cancel</button>
</mat-dialog-actions>
